import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import useCurrentLocation from "./hooks/currentLocation";
// import { Button } from "@nextui-org/react";
import React, { useEffect, useRef, useState } from "react";
import { buildAddressObject } from "./helpers/address";
import { InputDropdownSearch } from "../input_dropdown_search";
import { Button } from "@heroui/react";
// import { buildAddressObject } from "./helpers/address";
// import { InputDropdownSearch } from "../../../components/input_dropdown_search";
// import useCurrentLocation from "./hooks/currentLocation";
// const letsTradeAPIUrl = "https://lets-trade-client-dev.letstrade.global";
const INT_API_URL = process.env.LETS_TRADE_INTEGRATION_URL ?? "";
const CLIENT_API_URL = process.env.LETS_TRADE_CLIENT_URL ?? "";
export const AddressSearch = (props) => {
    const { currentLocation, getUserLocation } = useCurrentLocation();
    const { value, placeholder, label, errorText, required = false, showSubmitButton = true, onComplete, onSelection } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [location, setLocation] = useState(null);
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [predictions, setPredictions] = useState([]);
    const [isPredictionsLoading, setIsPredictionsLoading] = useState(false);
    const [fieldState, setFieldState] = useState({
        selectedKey: "",
        inputValue: "",
    });
    const inputRef = useRef(null);
    useEffect(() => {
        if (currentLocation) {
            setIsLoadingLocation(true);
            const { latitude, longitude } = currentLocation;
            fetch(`${INT_API_URL}/v1/google/coordinate/geocode?latitude=${latitude}&longitude=${longitude}`, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                setIsLoadingLocation(false);
                if (data.success) {
                    const location = { ...data.content, description: data.content.formatted_address };
                    setLocation(location);
                }
                else {
                    // console.log("Error finding user address.", data.message);
                }
            })
                .catch((error) => {
                // console.error("Error fetching address:");
            });
        }
    }, [currentLocation]);
    useEffect(() => {
        if (fieldState.inputValue) {
            setIsPredictionsLoading(true);
            const timeout = setTimeout(() => {
                fetch(`${CLIENT_API_URL}/v2/google/autocomplete?input=${encodeURIComponent(fieldState.inputValue)}&country=AU`, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((data) => {
                    setIsPredictionsLoading(false);
                    if (data.success) {
                        const updatedPredictions = data.content.filter((i) => i.place_id !== location?.place_id);
                        setPredictions(updatedPredictions);
                    }
                    else {
                        // console.log("Address Search ERROR", data.message);
                    }
                });
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [fieldState.inputValue]);
    const onSubmit = () => {
        setIsLoading(true);
        fetch(`${CLIENT_API_URL}/v2/google/placeiddetails?place_id=${fieldState.selectedKey}`, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((data) => {
            setIsLoading(false);
            if (data.success) {
                const address = buildAddressObject(data.content);
                if (address && onComplete) {
                    onComplete(address);
                }
            }
            else {
                console.log("Address Select ERROR", data.message);
            }
        });
    };
    const onInputChange = (value) => {
        setFieldState((prevState) => ({
            inputValue: value,
            selectedKey: value === "" ? null : prevState.selectedKey,
        }));
    };
    const onSelectionChange = (place_id) => {
        if (!place_id)
            return;
        const addressObj = predictions.find((item) => item.place_id === place_id) ?? location;
        setFieldState({
            ...fieldState,
            selectedKey: addressObj?.place_id || null,
        });
        onSelection && onSelection(place_id.toString());
    };
    return (React.createElement("div", { className: "text-center self-center w-full" },
        React.createElement(InputDropdownSearch, { list: predictions, value: fieldState.selectedKey, isLoading: isPredictionsLoading, currentLocation: location, onSearchChange: onInputChange, onSelectionChange: onSelectionChange, startingIcon: faSearch }),
        React.createElement("div", { className: "flex justify-center items-center flex-col gap-4 w-full pt-5" },
            React.createElement(Button, { size: "md", fullWidth: true, radius: "md", className: "w-80 ", variant: "bordered", color: "primary", isLoading: isLoadingLocation, isDisabled: isLoadingLocation, onPress: () => {
                    getUserLocation();
                    inputRef.current?.focus();
                } }, "Locate Me"),
            showSubmitButton && (React.createElement(Button, { color: "primary", size: "md", fullWidth: true, radius: "md", className: "w-80", isLoading: isLoading, isDisabled: !fieldState.selectedKey, onPress: () => onSubmit() }, "Done")))));
};
